import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { useNavigate } from "react-router-dom"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import DiscountModel from "./Model"

const formatDate = (date) => {
  if (!date) return ""
  return date.split(" ")[0]
}

const columns = [
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "type_label",
    header: "Type",
  },
  {
    accessorKey: "value",
    header: "Value",
  },
  {
    accessorKey: "is_active",
    header: "Status",
    cell: ({ row }) => (row.original.is_active ? "Active" : "Inactive"),
  },
  {
    header: "Starts At",
    cell: ({ row }) => formatDate(row.original.starts_at),
  },
  {
    header: "Ends At",
    cell: ({ row }) => formatDate(row.original.ends_at),
  },
]

export default function DiscountList() {
  return (
    <>
      <CrudProvider>
        <DiscountTable />
        <DiscountModel />
      </CrudProvider>
    </>
  )
}

function DiscountTable() {
  const navigate = useNavigate()
  const { openDialog, setOpenDialog } = useCrudContext()

  const handleOnView = (row) => {
    navigate(`/pos/discount/${row.id}`)
  }

  const handleOnAdd = () => {
    setOpenDialog(true)
  }
  return (
    <>
      <CustomTable
        columns={columns}
        apiPath="discount"
        action
        view
        label="Discounts"
        onView={handleOnView}
        onAdd={handleOnAdd}
      />
    </>
  )
}
